export const LEFT_COLOR = 'transparent'
export const RIGHT_COLOR = 'rgba(123, 97, 255, 0.12)'
